<template>
    <div class="intro-wrapper" v-src="'https://oss.cloud.custouch.com/res/84295/bg.png'" v-if="info">
        <div class="content-wrapper">
            <img class="addy" v-src="'https://oss.cloud.custouch.com/res/84296/img-Addy.png'" alt="" />
            <div class="content">{{ info.detail.desc }}</div>
        </div>
        <video playsinline="playsinline" controls="controls" v-src="video" poster></video>
        <div class="button-wrapper">
            <router-link :to="{ name: 'question' }" class="button">
                <img src="https://oss.cloud.custouch.com/res/84313/icon-question.png" alt="" />
                有问必答
            </router-link>
            <router-link class="button" :to="{ name: 'schoolTopic', params: { hId: addyId } }">
                <img src="https://oss.cloud.custouch.com/res/84314/icon-college.png" alt="" />
                助剂学院
            </router-link>
        </div>
    </div>
</template>
<script>
import { getDataRows, getVideoConfig } from '@custouch/proxy-use'

export default {
    data() {
        return {
            info: null,
            video: '',
            addyId: window.env.CMS.hierarchy.school.addy
        }
    },
    async created() {
        const [info] = (
            await getDataRows({
                dataTemplateId: window.env.CMS.template.intro,
                searchKey: 'addy',
                customIds: ['name'],
                index: 1,
                size: 1
            })
        ).data
        if (info) {
            this.video = (
                await getVideoConfig(info.detail.video.match(/([^/?]+)$/)[1])
            )?.downloadUrl
            this.info = info
        }
    }
}
</script>
<style lang="less" scoped>
.intro-wrapper {
    padding: 1rem;
    background: no-repeat center/cover;
}

.content-wrapper {
    width: 100%;
    box-shadow: 0 0.13rem 0.5rem 0 rgba(0, 166, 235, 0.3);
    border-radius: 0.6rem;
    display: flex;
    color: #004da0;
    justify-content: space-between;
    padding: 1rem;

    .addy {
        width: 4.5rem;
        object-fit: contain;
        object-position: bottom;
        align-items: flex-end;
        flex-shrink: 0;
        margin-right: 1.5rem;
    }

    .content {
        width: 70%;
        text-align: justify;
        white-space: pre-line;
    }
}

.button-wrapper {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 1.5rem;
}

.button {
    color: #fff;
    width: 5.4rem;
    height: 1.8rem;
    background: #00a6eb;
    border-radius: 0.3rem;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 1rem;
        object-fit: contain;
        margin-right: 0.3rem;
    }
}

video {
    width: 100%;
    margin: 1rem 0;
}
</style>
